
<template>
    <div class="PHD">
        <div class="container">
            <h1 class="page-heading mb-3">PHD Left Navigation Demo</h1>

            <div class="row mb-5">
                <div class="col-12 col-md-4">
                    <!-- Dev Notes: 
                        This is how you use the left navigation with variable assigned data.  Similar to other items on the site, this data can be assigned to a variable before you call this component, with the variable name replacing 'demoData' below in the 'sc-data' attribute.

                        Full data structure (array of objects) can be found at the bottom of this page where demoData is created.
                    -->
                    <!-- Begin: Left nav -->
                    <phd-left-nav :sc-data="demoData"></phd-left-nav>
                    <!-- End:   Left Nav -->
                </div>

                <div class="col-12 col-md-8">
                    <h2>Fake content simulating rich text</h2>
                    <p>Navigation on the left is an example using variable assigned data.</p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus fugit quaerat facere sapiente vel, alias enim dolor reiciendis cupiditate est non nostrum asperiores provident labore voluptatum voluptatem dolorum. Sint, sed.</p>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-4">
                    <!-- Dev Notes: 
                        This is how you use the left navigation with inline content.  Note that this is, technically, the same as the variable example above... but we're inlined the content here to avoid the extra <script> tag on the page.

                        The full, uncompressed, data structure can be seen at the bottom of this file in the declaration of 'demoData'.
                    -->
                    <!-- Begin: Left nav -->
                    <phd-left-nav :sc-data="[{target: '_blank',text: 'I <3 Kittens',url: 'https://www.eyebleach.me/kittens/'},{active: true,target: '_blank',text: 'Cats!',url: 'https://www.eyebleach.me/cats/'},{target: '_blank',text: 'I like dogs Dogs',url: 'https://www.eyebleach.me/dogs/'},{target: '_blank',text: 'Show me some nature and I shall tell you how pretty it is',url: 'https://www.eyebleach.me/nature/'},{target: '_blank',text: 'I wanna go fast!',url: 'https://www.eyebleach.me/faster/'},{text: 'No target on this one',url: 'https://giantbomb.com'}
                    ]"></phd-left-nav>
                    <!-- End:   Left Nav -->
                </div>

                <div class="col-12 col-md-8">
                    <h2>Fake content simulating rich text</h2>
                    <p>Navigation on the left is an example using inline assigned data.</p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus fugit quaerat facere sapiente vel, alias enim dolor reiciendis cupiditate est non nostrum asperiores provident labore voluptatum voluptatem dolorum. Sint, sed.</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // note that 'target' and 'active' are the optional items here.  'target' can be left off completely, or left as an empty string.  While 'active' is technically optional, ONE item should have it (and only one) in order to render appropriately.  That item should corrospod to which ever page they are on.
                demoData: [
                    {
                        target: '_blank',
                        text: 'I <3 Kittens',
                        url: 'https://www.eyebleach.me/kittens/'
                    },
                    {
                        target: '_blank',
                        text: 'Cats!',
                        url: 'https://www.eyebleach.me/cats/'
                    },
                    {
                        target: '_blank',
                        text: 'I like dogs Dogs',
                        url: 'https://www.eyebleach.me/dogs/'
                    },
                    {
                        target: '_blank',
                        text: 'Show me some nature',
                        url: 'https://www.eyebleach.me/nature/'
                    },
                    {
                        active: true,
                        target: '_blank',
                        text: 'I wanna go fast!',
                        url: 'https://www.eyebleach.me/faster/'
                    },
                    {
                        text: 'No target on this one',
                        url: 'https://giantbomb.com'
                    }
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// demo/components/phd/phd-left-nav-demo.vue